import { useQuery } from "react-query";
import { clientsApi } from "frontend/src/api/clients";
import { clientsCacheKey } from "./shared";
export var useClients = function (request) {
    return useQuery([clientsCacheKey, request], function () { return clientsApi.getMany(request); });
};
export var useClient = function (id) {
    return useQuery([clientsCacheKey, id], function () { return clientsApi.getOne(id !== null && id !== void 0 ? id : -1); }, {
        enabled: Boolean(id),
    });
};
export var useClientActivityLogs = function (id, request) {
    return useQuery([clientsCacheKey, id, "activity-logs", request], function () {
        return clientsApi.getActivityLogs(id, request);
    });
};
export var useAllClientActivityLogs = function (request) {
    return useQuery([clientsCacheKey, "all-activity-logs", request], function () {
        return clientsApi.getAllActivityLogs(request);
    });
};
export var useClientActivityLogFileInfo = function () {
    return useQuery([clientsCacheKey, "activity-log-file"], function () {
        return clientsApi.getActivityLogFileInfo();
    });
};
